module.exports = __webpack_public_path__ + "img/Arrow.88954fd8.svg";